import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// assets
import RightArrowLarge from "assets/icons/right-arrow.svg";
import RightArrowSmall from "assets/icons/right-arrow-small.svg";

const RightArrow = ({ onClick, size = "L" }) => {
  return (
    <Icon onClick={onClick}>
      <img src={size === "L" ? RightArrowLarge : RightArrowSmall} />
    </Icon>
  );
};

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  outline: none;
  &:hover {
    cursor: pointer;
  }
`;

RightArrow.propTypes = {
  onClick: PropTypes.func,
};

export default RightArrow;
